import { Modal } from "antd";
import FormFiltros from "./FormFiltros";
import FooterModalFiltros from "./FooterModalFiltros";
import Toolbar from "ui/components/Toolbar";
import { useEffect, useState, useCallback } from "react";

export interface FiltroRelatorioDemonstrativoProps {
  contaCategoriaIds?: string[];
  contaBancariaIds?: string[];
  centrosDeCustoIds?: string[];
}

interface ModalFiltrosProps {
  isOpenModal: boolean;
  onClose: () => any;
  filtro: FiltroRelatorioDemonstrativoProps;
  onChangeFiltro: (v: Partial<FiltroRelatorioDemonstrativoProps>) => void;
  numeroFiltroSelecionados: number;
}

function ModalFiltros({
  isOpenModal,
  onClose,
  filtro,
  onChangeFiltro,
  numeroFiltroSelecionados,
}: ModalFiltrosProps) {
  const [localFiltro, setLocalFiltro] = useState(filtro);

  const onChangeLocalFiltro = useCallback(
    (_filtro: Partial<FiltroRelatorioDemonstrativoProps>) => {
      setLocalFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  useEffect(() => {
    if (isOpenModal) {
      onChangeLocalFiltro(filtro);
    }
  }, [filtro, isOpenModal, onChangeLocalFiltro]);

  useEffect(() => {
    if (isOpenModal) {
      onChangeLocalFiltro(filtro);
    }
  }, [filtro, isOpenModal, onChangeLocalFiltro]);

  return (
    <Modal
      centered
      visible={isOpenModal}
      footer={
        <FooterModalFiltros
          value={numeroFiltroSelecionados}
          onCancel={onClose}
          onSubmit={() => {
            onChangeFiltro(localFiltro);
            onClose();
          }}
        />
      }
      onCancel={onClose}
      destroyOnClose
      width="700px"
      className="antd-custom-header"
      title={<Toolbar title="Filtros" onClose={onClose} border="0px" />}
      closable={false}
    >
      <FormFiltros filtro={localFiltro} onChangeFiltro={onChangeLocalFiltro} />
    </Modal>
  );
}

export default ModalFiltros;
